// extracted by mini-css-extract-plugin
export default {"clickable":"link-styles_clickable__K6B8i","plainLink":"link-styles_plainLink__1nju0"};